

export default {
    SET_TOTAL(state, payload){
        state.totalRecords = payload
    },
    SET_TOTAL_RC(state, payload){
        state.totalReferal = payload
    },
    SET_REFERAL_LIST(state, payload){
        state.referalList = payload
    }
}
